import { useState } from "react";
import { useParams } from "@tanstack/react-router";
import { useAuthenticatedSuspenseQuery } from "@/queries/shared";
import LayoutContentArea from "@/components/layout/LayoutContentArea";
import Breadcrumb from "@/components/shared/BreadCrumb";
import { LuUser } from "react-icons/lu";
import { Card } from "react-bootstrap";
import { UserProfileForm } from "@/components/user-management/components/UserProfileForm";
import { User, UserOrg } from "@/models/user";

export default function UserProfilePage() {
  const params = useParams({ strict: false });
  const leaid = params.leaid ?? "";
  const userid = params.userid ?? "";

  const url = userid
    ? `/json/account/${leaid}/users/${userid}`
    : "/json/identity/profile";

  const queryKey = userid ? ["user", leaid, userid] : ["identity-profile"];

  const { data: fetchedUser } = useAuthenticatedSuspenseQuery<User<UserOrg>>(
    url,
    queryKey
  );

  const [user, setUser] = useState<User<UserOrg>>(fetchedUser);

  const fullName =
    `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() ||
    user.userName ||
    user.email ||
    "Profile";

  const breadcrumbItems = [
    {
      label: "Home",
      to: "/$leaid" as const,
      params: { leaid },
      ariaLabel: "Go to Home",
      isHome: true,
    },
    { label: "Profile" },
    { label: fullName },
  ];

  return (
    <LayoutContentArea
      headingText={null}
      noBorder={true}
      showHeadingSection={false}
    >
      <Breadcrumb items={breadcrumbItems} />
      <div style={{ marginBottom: "1.5rem" }} />
      <Card className="no-padding card-border mb-5 overflow-hidden shadow">
        <div
          className="d-flex align-items-center gap-2 px-4 py-3 fw-semibold"
          style={{
            background: "var(--color-p3)",
            color: "#fff",
            fontSize: "0.975rem",
          }}
        >
          <LuUser size={16} style={{ flexShrink: 0 }} />
          Personal Information
        </div>
        <UserProfileForm user={user} onUpdate={setUser} />
      </Card>
    </LayoutContentArea>
  );
}
